import React, { Component } from "react";
import SEO from "react-seo-component";
import axios from "axios";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import constants from "../../Constants";

const baseURL = constants.baseURL;

class Section extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Form fields
      full_name: "",
      email: "",
      mobile: "",
      city_province: "",
      languages: "",
      primary_platform: "",
      tiktok_handle: "",
      tiktok_followers: "",
      instagram_handle: "",
      instagram_followers: "",
      youtube_link: "",
      youtube_subscribers: "",
      other_platforms: "",
      sample_content_links: "",
      content_type: [],
      comfortable_with_qiktruck_topics: "",
      preferred_rate_per_video: "",
      availability_per_month: "",
      consent_content_rights: false,
      consent_communications: false,
      confirm_information_true: false,
      // UI state
      submitting: false,
      successMessage: "",
      errorMessage: "",
      fieldErrors: {},
      showSuccessModal: false,
    };
  }

  scrollToForm = () => {
    const el = document.getElementById("creator-application-form");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox" && name === "content_type") {
      const { content_type } = this.state;
      const newValues = checked
        ? [...content_type, value]
        : content_type.filter((v) => v !== value);
      this.setState({ content_type: newValues });
    } else if (type === "checkbox") {
      this.setState({ [name]: checked });
    } else {
      this.setState({ [name]: value });
    }
  };

  validate = () => {
    const errors = {};
    const {
      full_name,
      email,
      mobile,
      city_province,
      languages,
      primary_platform,
      sample_content_links,
      content_type,
      comfortable_with_qiktruck_topics,
      preferred_rate_per_video,
      availability_per_month,
      consent_content_rights,
      consent_communications,
      confirm_information_true,
    } = this.state;

    const isNonEmpty = (v) => v && v.toString().trim().length > 0;

    if (!isNonEmpty(full_name)) errors.full_name = "Full name is required.";
    if (!isNonEmpty(email) || !/\S+@\S+\.\S+/.test(email)) {
      errors.email = "Valid email address is required.";
    }
    if (!isNonEmpty(mobile)) errors.mobile = "Mobile number is required.";
    if (!isNonEmpty(city_province))
      errors.city_province = "City and province are required.";
    if (!isNonEmpty(languages))
      errors.languages = "Languages are required.";

    if (!isNonEmpty(primary_platform))
      errors.primary_platform = "Primary platform is required.";

    if (!isNonEmpty(sample_content_links))
      errors.sample_content_links = "Sample content links are required.";
    if (!content_type || content_type.length === 0)
      errors.content_type = "Select at least one content type.";
    if (!isNonEmpty(comfortable_with_qiktruck_topics))
      errors.comfortable_with_qiktruck_topics =
        "Please select if you are comfortable with these topics.";

    if (!isNonEmpty(preferred_rate_per_video))
      errors.preferred_rate_per_video =
        "Preferred rate per video is required.";
    if (!isNonEmpty(availability_per_month))
      errors.availability_per_month =
        "Monthly availability is required.";

    if (!consent_content_rights)
      errors.consent_content_rights =
        "You must agree to content rights.";
    if (!consent_communications)
      errors.consent_communications =
        "You must agree to communications consent.";
    if (!confirm_information_true)
      errors.confirm_information_true =
        "You must confirm the information is true.";

    return errors;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const fieldErrors = this.validate();
    if (Object.keys(fieldErrors).length > 0) {
      this.setState({ fieldErrors });
      return;
    }

    this.setState({
      submitting: true,
      successMessage: "",
      errorMessage: "",
      fieldErrors: {},
    });

    try {
      const {
        // Form fields
        full_name,
        email,
        mobile,
        city_province,
        languages,
        primary_platform,
        tiktok_handle,
        tiktok_followers,
        instagram_handle,
        instagram_followers,
        youtube_link,
        youtube_subscribers,
        other_platforms,
        sample_content_links,
        content_type,
        comfortable_with_qiktruck_topics,
        preferred_rate_per_video,
        availability_per_month,
        consent_content_rights,
        consent_communications,
        confirm_information_true,
      } = this.state;

      const payload = {
        full_name,
        email,
        mobile,
        city_province,
        languages,
        primary_platform,
        tiktok_handle,
        tiktok_followers,
        instagram_handle,
        instagram_followers,
        youtube_link,
        youtube_subscribers,
        other_platforms,
        sample_content_links,
        content_type: content_type.join(", "),
        comfortable_with_qiktruck_topics,
        preferred_rate_per_video,
        availability_per_month,
        consent_content_rights,
        consent_communications,
        confirm_information_true,
      };

      await axios.post(`${baseURL}/api/creator-applications`, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      this.setState({
        submitting: false,
        successMessage:
          "Thank you. Your application has been submitted. Our team will review your profile and contact you if you are selected for the next steps.",
        errorMessage: "",
        showSuccessModal: true,
      });
    } catch (error) {
      let apiErrors = {};
      if (error.response && error.response.data && error.response.data.errors) {
        apiErrors = error.response.data.errors;
      }
      this.setState({
        submitting: false,
        errorMessage:
          "There was a problem submitting your application. Please try again in a few minutes. If the issue continues, email support@qiktruck.co.za.",
        fieldErrors: apiErrors,
      });
    }
  };

  render() {
    const {
      submitting,
      errorMessage,
      fieldErrors,
      content_type,
      showSuccessModal,
    } = this.state;

    return (
      <React.Fragment>
        <SEO
          title="QikTruck Creator Program - UGC Creators & Influencers in South Africa"
          titleTemplate="QikTruck"
          titleSeparator="-"
          description="Apply to the QikTruck Creator Program and get paid for short-form UGC content about deliveries, moving and small business life in South Africa. Ideal for TikTok, Instagram and YouTube creators looking for brand deals."
          image="https://media.qiktruck.co.za/marketplace-builder-program.png"
          pathname="https://qiktruck.co.za/creator-program"
          twitterUsername="qiktrucksa"
        />

        {/* Hero: compact, aligned layout */}
        <section
          id="home"
          className="creator-hero bg-dark"
          style={{ color: "#ffffff", padding: "56px 0 40px" }}
        >
          <Container>
            <Row className="align-items-center justify-content-between">
              <Col lg={6} md={12} className="mb-5 mb-lg-0">
                <div className="hero-content text-center text-md-left">
                  <Badge color="success" pill className="mb-3 px-3 py-2">
                    Now accepting South African creators
                  </Badge>
                  <h1 className="hero-title mb-4">
                    <span className="highlight-text">QikTruck</span>
                    <br />
                    Creator Program
                  </h1>
                  <p className="hero-subtitle mb-4">
                    Get paid to create short-form UGC about deliveries,
                    moving and small business life – without losing your
                    own style and voice.
                  </p>
                  <ul className="hero-bullets list-unstyled mb-3 text-center text-md-left">
                    <li>✅ Paid per approved video or photo set</li>
                    <li>✅ Clear, simple content briefs</li>
                    <li>✅ For TikTok, Instagram, YouTube & Facebook creators</li>
                  </ul>
                  <div
                    className="hero-actions d-flex flex-column flex-sm-row justify-content-center justify-content-lg-start"
                    style={{ gap: "8px" }}
                  >
                    <Button
                      color="success"
                      size="lg"
                      className="mb-2"
                      onClick={this.scrollToForm}
                      disabled={submitting}
                    >
                      Apply now
                    </Button>
                    <Button
                      color="outline-light"
                      size="lg"
                      className="mb-2"
                      onClick={() => {
                        const el = document.getElementById("how-it-works");
                        if (el) el.scrollIntoView({ behavior: "smooth" });
                      }}
                    >
                      How it works
                    </Button>
                  </div>
                  <div className="hero-stats mt-3">
                    <Row className="g-3">
                      <Col md={4} className="text-center mb-3">
                        <div className="stat-number">R800+</div>
                        <div className="stat-label">
                          Typical rate per UGC video
                        </div>
                      </Col>
                      <Col md={4} className="text-center mb-3">
                        <div className="stat-number">100K+</div>
                        <div className="stat-label">
                          Deliveries powered yearly
                        </div>
                      </Col>
                      <Col md={4} className="text-center mb-3">
                        <div className="stat-number">SA</div>
                        <div className="stat-label">
                          Focused on South African creators
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
              <Col
                lg={5}
                md={12}
                className="d-flex justify-content-center justify-content-lg-end"
              >
                <div className="hero-image-container mt-3 mt-lg-0" style={{ maxWidth: "520px" }}>
                  <img
                    src="https://media.qiktruck.co.za/creator-program-hero.png"
                    alt="Placeholder for QikTruck Creator Program hero"
                    className="hero-image img-fluid"
                    style={{
                      width: "100%",
                      height: "auto",
                      objectFit: "cover",
                      borderRadius: "16px",
                    }}
                  />
                  <div className="floating-card">
                    <div className="card-content">
                      <h5>UGC & Influencer Friendly</h5>
                      <p className="mb-0">Perfect for creators who love short-form video.</p>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* How it works */}
        <section className="section bg-light" id="how-it-works">
          <Container>
            <Row className="justify-content-center mb-5">
              <Col lg={8} className="text-center px-3">
                <h2 className="section-title">How the QikTruck Creator Program works</h2>
                <p className="section-subtitle">
                  A simple 3-step process built for busy creators, influencers
                  and UGC specialists.
                </p>
              </Col>
            </Row>
            <Row>
              <Col md={4} className="mb-4">
                <Card className="h-100 border-0 shadow-sm">
                  <CardBody>
                    <Badge color="primary" pill>
                      Step 1
                    </Badge>
                    <h5 className="mt-3">
                      We send you clear content briefs.
                    </h5>
                    <p className="mb-0">
                      You’ll receive detailed ideas, key messages and example
                      content so you know exactly what to film.
                    </p>
                  </CardBody>
                </Card>
              </Col>
              <Col md={4} className="mb-4">
                <Card className="h-100 border-0 shadow-sm">
                  <CardBody>
                    <Badge color="primary" pill>
                      Step 2
                    </Badge>
                    <h5 className="mt-3">
                      You shoot short vertical videos or photos.
                    </h5>
                    <p className="mb-0">
                      Create in your own tone, language and style – TikTok,
                      Reels, Shorts or Stories.
                    </p>
                  </CardBody>
                </Card>
              </Col>
              <Col md={4} className="mb-4">
                <Card className="h-100 border-0 shadow-sm">
                  <CardBody>
                    <Badge color="primary" pill>
                      Step 3
                    </Badge>
                    <h5 className="mt-3">
                      We approve and pay you per content piece.
                    </h5>
                    <p className="mb-0">
                      Once approved, your content is added to campaigns and you
                      get paid per deliverable.
                    </p>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Who it's for & benefits */}
        <section className="section">
          <Container>
            <Row className="mb-5">
              <Col lg={6} className="mb-4">
                <h2>Who is this creator program for?</h2>
                <p>
                  We’re looking for South African creators, influencers and UGC
                  partners who love making short-form content and talking about
                  real life – from moving flats to running small businesses.
                </p>
                <ul className="feature-list">
                  <li>🎥 TikTok, Instagram Reels, YouTube Shorts or Facebook creators</li>
                  <li>📱 Comfortable filming vertical video on your phone</li>
                  <li>🌍 Based in South Africa with a public profile</li>
                  <li>🧠 Enjoy telling authentic, practical stories</li>
                </ul>
              </Col>
              <Col lg={6}>
                <h3>Why creators love working with QikTruck</h3>
                <Row>
                  <Col md={6} className="mb-3">
                    <Card className="h-100 border-0 shadow-sm">
                      <CardBody>
                        <h6>Predictable briefs</h6>
                        <p className="mb-0">
                          Clear deliverables, examples and timelines for every
                          campaign.
                        </p>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md={6} className="mb-3">
                    <Card className="h-100 border-0 shadow-sm">
                      <CardBody>
                        <h6>Fair rates</h6>
                        <p className="mb-0">
                          You set your preferred rate per short-form video in
                          the application.
                        </p>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md={6} className="mb-3">
                    <Card className="h-100 border-0 shadow-sm">
                      <CardBody>
                        <h6>Creative freedom</h6>
                        <p className="mb-0">
                          Keep your unique style, language and personality in
                          every piece of content.
                        </p>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md={6} className="mb-3">
                    <Card className="h-100 border-0 shadow-sm">
                      <CardBody>
                        <h6>Long-term collabs</h6>
                        <p className="mb-0">
                          Deliver great work and we’ll send more briefs over
                          time.
                        </p>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Application form */}
        <section className="section bg-light" id="creator-application-form">
          <Container>
            <Row className="mb-4">
              <Col md={8} className="px-3">
                <h2>Creator application form</h2>
                <p>
                  Complete the form below so our team can review your profile.
                  If you are approved, we will contact you with next steps and
                  paid content briefs.
                </p>
              </Col>
            </Row>

            {errorMessage && (
              <Row className="mb-3">
                <Col md={8}>
                  <div className="alert alert-danger" role="alert">
                    {errorMessage}
                  </div>
                </Col>
              </Row>
            )}

            <Row>
              <Col md={8} className="mb-4">
                <Card className="shadow-sm border-0">
                  <CardBody>
                    <Form >
                      {/* Personal details */}
                      <h5 className="mt-3 mb-3">Personal details</h5>
                      <FormGroup>
                        <Label for="full_name">
                          Full name <span className="text-danger">*</span>
                        </Label>
                        <Input
                          id="full_name"
                          name="full_name"
                          placeholder="Name and surname"
                          onChange={this.handleInputChange}
                        />
                        {fieldErrors.full_name && (
                          <small className="text-danger">
                            {fieldErrors.full_name}
                          </small>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for="email">
                          Email address <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="email"
                          id="email"
                          name="email"
                          placeholder="you@example.com"
                          onChange={this.handleInputChange}
                        />
                        {fieldErrors.email && (
                          <small className="text-danger">
                            {fieldErrors.email}
                          </small>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for="mobile">
                          Mobile number (WhatsApp){" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          id="mobile"
                          name="mobile"
                          placeholder="+27 82 123 4567"
                          onChange={this.handleInputChange}
                        />
                        {fieldErrors.mobile && (
                          <small className="text-danger">
                            {fieldErrors.mobile}
                          </small>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for="city_province">
                          City and province{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          id="city_province"
                          name="city_province"
                          placeholder="Johannesburg, Gauteng"
                          onChange={this.handleInputChange}
                        />
                        {fieldErrors.city_province && (
                          <small className="text-danger">
                            {fieldErrors.city_province}
                          </small>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for="languages">
                          Languages you create content in{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          id="languages"
                          name="languages"
                          placeholder="English, isiZulu, Sesotho"
                          onChange={this.handleInputChange}
                        />
                        {fieldErrors.languages && (
                          <small className="text-danger">
                            {fieldErrors.languages}
                          </small>
                        )}
                      </FormGroup>

                      {/* Social profiles */}
                      <h5 className="mt-4 mb-3">
                        Social media profiles and follower counts
                      </h5>
                      <FormGroup>
                        <Label for="primary_platform">
                          Primary platform{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="select"
                          id="primary_platform"
                          name="primary_platform"
                          onChange={this.handleInputChange}
                          defaultValue=""
                        >
                          <option value="" disabled>
                            Select primary platform
                          </option>
                          <option>TikTok</option>
                          <option>Instagram</option>
                          <option>YouTube</option>
                          <option>Facebook</option>
                          <option>Other</option>
                        </Input>
                        {fieldErrors.primary_platform && (
                          <small className="text-danger">
                            {fieldErrors.primary_platform}
                          </small>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for="tiktok_handle">TikTok handle</Label>
                        <Input
                          id="tiktok_handle"
                          name="tiktok_handle"
                          placeholder="@yourhandle"
                          onChange={this.handleInputChange}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label for="tiktok_followers">
                          TikTok follower count
                        </Label>
                        <Input
                          type="number"
                          id="tiktok_followers"
                          name="tiktok_followers"
                          placeholder="Example: 12500"
                          onChange={this.handleInputChange}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label for="instagram_handle">Instagram handle</Label>
                        <Input
                          id="instagram_handle"
                          name="instagram_handle"
                          placeholder="@yourhandle"
                          onChange={this.handleInputChange}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label for="instagram_followers">
                          Instagram follower count
                        </Label>
                        <Input
                          type="number"
                          id="instagram_followers"
                          name="instagram_followers"
                          placeholder="Example: 4300"
                          onChange={this.handleInputChange}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label for="youtube_link">YouTube channel link</Label>
                        <Input
                          type="url"
                          id="youtube_link"
                          name="youtube_link"
                          placeholder="https://youtube.com/@yourchannel"
                          onChange={this.handleInputChange}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label for="youtube_subscribers">
                          YouTube subscriber count
                        </Label>
                        <Input
                          type="number"
                          id="youtube_subscribers"
                          name="youtube_subscribers"
                          placeholder="Example: 800"
                          onChange={this.handleInputChange}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label for="other_platforms">
                          Other platforms and follower counts
                        </Label>
                        <Input
                          type="textarea"
                          id="other_platforms"
                          name="other_platforms"
                          placeholder="List any other platforms and follower numbers, if relevant."
                          onChange={this.handleInputChange}
                        />
                      </FormGroup>

                      {/* Content examples and type */}
                      <h5 className="mt-4 mb-3">
                        Content examples and type
                      </h5>
                      <FormGroup>
                        <Label for="sample_content_links">
                          Links to 2 or 3 sample videos or posts{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="textarea"
                          id="sample_content_links"
                          name="sample_content_links"
                          placeholder="Paste links to your best content here."
                          onChange={this.handleInputChange}
                        />
                        {fieldErrors.sample_content_links && (
                          <small className="text-danger">
                            {fieldErrors.sample_content_links}
                          </small>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label>
                          Type of content you mostly create{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <div>
                          {[
                            "Lifestyle",
                            "Comedy or skits",
                            "Small business and side hustles",
                            "Educational or how to",
                            "Vlogs",
                            "Other",
                          ].map((label) => (
                            <FormGroup check inline key={label}>
                              <Label check>
                                <Input
                                  type="checkbox"
                                  name="content_type"
                                  value={label}
                                  checked={content_type.includes(label)}
                                  onChange={this.handleInputChange}
                                />{" "}
                                {label}
                              </Label>
                            </FormGroup>
                          ))}
                        </div>
                        {fieldErrors.content_type && (
                          <div>
                            <small className="text-danger">
                              {fieldErrors.content_type}
                            </small>
                          </div>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label>
                          Are you comfortable creating content about
                          deliveries, moving, small businesses and drivers{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <div>
                          {["Yes", "No"].map((val) => (
                            <FormGroup check inline key={val}>
                              <Label check>
                                <Input
                                  type="radio"
                                  name="comfortable_with_qiktruck_topics"
                                  value={val}
                                  onChange={this.handleInputChange}
                                />{" "}
                                {val}
                              </Label>
                            </FormGroup>
                          ))}
                        </div>
                        {fieldErrors.comfortable_with_qiktruck_topics && (
                          <div>
                            <small className="text-danger">
                              {fieldErrors.comfortable_with_qiktruck_topics}
                            </small>
                          </div>
                        )}
                      </FormGroup>

                      {/* Rates and availability */}
                      <h5 className="mt-4 mb-3">Rates and availability</h5>
                      <FormGroup>
                        <Label for="preferred_rate_per_video">
                          Preferred rate per short form video (15 to 30
                          seconds) <span className="text-danger">*</span>
                        </Label>
                        <Input
                          id="preferred_rate_per_video"
                          name="preferred_rate_per_video"
                          placeholder="Example: R800"
                          onChange={this.handleInputChange}
                        />
                        {fieldErrors.preferred_rate_per_video && (
                          <small className="text-danger">
                            {fieldErrors.preferred_rate_per_video}
                          </small>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for="availability_per_month">
                          Monthly availability{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="select"
                          id="availability_per_month"
                          name="availability_per_month"
                          onChange={this.handleInputChange}
                          defaultValue=""
                        >
                          <option value="" disabled>
                            Select availability
                          </option>
                          <option>1 - 2 videos per month</option>
                          <option>3 - 5 videos per month</option>
                          <option>6 or more videos per month</option>
                        </Input>
                        {fieldErrors.availability_per_month && (
                          <small className="text-danger">
                            {fieldErrors.availability_per_month}
                          </small>
                        )}
                      </FormGroup>

                      {/* Consents */}
                      <h5 className="mt-4 mb-3">Consents</h5>
                      <FormGroup check className="mb-2">
                        <Label check>
                          <Input
                            type="checkbox"
                            name="consent_content_rights"
                            onChange={this.handleInputChange}
                          />{" "}
                          I agree that QikTruck may use my approved content on
                          its social media, website and digital advertising,
                          with appropriate credit where applicable.
                        </Label>
                      </FormGroup>
                      {fieldErrors.consent_content_rights && (
                        <div>
                          <small className="text-danger">
                            {fieldErrors.consent_content_rights}
                          </small>
                        </div>
                      )}
                      <FormGroup check className="mb-2">
                        <Label check>
                          <Input
                            type="checkbox"
                            name="consent_communications"
                            onChange={this.handleInputChange}
                          />{" "}
                          I agree that QikTruck may contact me via email or
                          WhatsApp about creator opportunities.
                        </Label>
                      </FormGroup>
                      {fieldErrors.consent_communications && (
                        <div>
                          <small className="text-danger">
                            {fieldErrors.consent_communications}
                          </small>
                        </div>
                      )}
                      <FormGroup check className="mb-3">
                        <Label check>
                          <Input
                            type="checkbox"
                            name="confirm_information_true"
                            onChange={this.handleInputChange}
                          />{" "}
                          I confirm that the information I have provided is
                          true and correct.
                        </Label>
                      </FormGroup>
                      {fieldErrors.confirm_information_true && (
                        <div>
                          <small className="text-danger">
                            {fieldErrors.confirm_information_true}
                          </small>
                        </div>
                      )}

                      <div className="d-flex justify-content-between align-items-center mt-4">
                        <Button
                          color="primary"
                          type="submit"
                          disabled={submitting}
                          onClick={this.handleSubmit}
                        >
                          {submitting ? "Submitting..." : "Submit application"}
                        </Button>
                        <small className="text-muted">
                          This form is for South African creators only.
                        </small>

                      </div>
                    </Form>
                    {
                      fieldErrors && Object.keys(fieldErrors).length > 0 &&
                      <p
                        style={
                          {
                            color: "red",
                            fontSize: "12px",
                            marginTop: "10px",
                            marginBottom: "10px",
                          }
                        }
                      >
                        Check the form for errors
                      </p>
                    }
                  </CardBody>
                </Card>
              </Col>
              <Col md={4} className="mt-4 mt-md-0">
                <Card className="border-0 shadow-sm h-100">
                  <CardBody>
                    <h5>Tips for a strong application</h5>
                    <ul className="feature-list small">
                      <li>Share links to your best-performing videos.</li>
                      <li>Mention if you’ve worked with brands before.</li>
                      <li>Be clear about your rates and availability.</li>
                      <li>Include content in any South African languages you use.</li>
                    </ul>
                    <p className="small text-muted mb-0">
                      We review every application carefully. If you’re a fit for
                      an upcoming campaign, our team will reach out via email or
                      WhatsApp.
                    </p>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Success modal */}
        <Modal
          isOpen={showSuccessModal}
          toggle={() => this.setState({ showSuccessModal: false })}
          centered
        >
          <ModalHeader toggle={() => this.setState({ showSuccessModal: false })}>
            Application submitted
          </ModalHeader>
          <ModalBody>
            <p className="mb-2">
              Thank you. Your application has been submitted.
            </p>
            <p className="mb-0">
              Our team will review your profile and contact you if you are
              selected for the next steps and paid content briefs.
            </p>
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={() => this.setState({ showSuccessModal: false })}
            >
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

export default Section;

// Inline styles scoped to this page to ensure good contrast and non-conflicting UI
// Reuse marketplace-hero look but keep things readable over the image
/* eslint-disable */
const styles = (
  <style jsx>{`
    .creator-hero {
      background: linear-gradient(135deg, #111827 0%, #0f766e 100%);
      position: relative;
      overflow: hidden;
      color: #ffffff;
    }

    .creator-hero .hero-gradient-overlay {
      background: rgba(15, 23, 42, 0.6);
      min-height: 100vh;
      display: flex;
      align-items: center;
    }

    .creator-hero .hero-title {
      font-size: 3rem;
      font-weight: 800;
      line-height: 1.1;
    }

    @media (min-width: 992px) {
      .creator-hero .hero-title {
        font-size: 3.5rem;
      }
    }

    .creator-hero .hero-subtitle {
      font-size: 1.25rem;
      font-weight: 600;
      opacity: 0.95;
    }

    .creator-hero .hero-bullets li {
      margin-bottom: 0.35rem;
      opacity: 0.95;
    }

    .creator-hero .hero-image-container {
      position: relative;
      max-width: 480px;
    }

    .creator-hero .hero-image {
      box-shadow: 0 18px 45px rgba(0, 0, 0, 0.45);
      border-radius: 16px;
    }

    .creator-hero .floating-card {
      position: absolute;
      bottom: 16px;
      left: 16px;
      right: auto;
      background: rgba(15, 23, 42, 0.9);
      color: #f9fafb;
      padding: 14px 18px;
      border-radius: 12px;
      max-width: 220px;
      box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5);
      font-size: 0.85rem;
    }

    .creator-hero .floating-card h5 {
      font-size: 1rem;
      margin-bottom: 4px;
    }

    .creator-hero .stat-number {
      font-size: 1.6rem;
      font-weight: 700;
      color: #a5f3fc;
    }

    .creator-hero .stat-label {
      font-size: 0.8rem;
      color: #e5e7eb;
      opacity: 0.9;
    }

    .section-title {
      color: #111827;
    }

    .section-subtitle {
      color: #4b5563;
    }

    .feature-list {
      list-style: none;
      padding-left: 0;
    }

    .feature-list li::before {
      content: "•";
      color: #0f766e;
      display: inline-block;
      width: 1rem;
      margin-left: -1rem;
    }
  `}</style>
);
/* eslint-enable */
